import { ButtonBase, Typography } from "@mui/material";
import { AddIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { Radius, Spacing } from "Infrastructure/Themes/Themes";
import type { FC } from "react";

const ICON_SIZE = 24;
const DEFAULT_MIN_HEIGHT = 130;

type Props = {
  readonly title: string;
  readonly subtitle?: string;
  /** Matches the height of a single item, so the tile doesn't look squashed when it's alone in its row. */
  readonly minHeight?: number;
  readonly disabled?: boolean;
  readonly onClick: () => void;
};

export const FormDrawerAddTile: FC<Props> = ({ title, subtitle, minHeight = DEFAULT_MIN_HEIGHT, disabled = false, onClick }) => (
  <ButtonBase
    disabled={disabled}
    onClick={onClick}
    sx={(theme) => ({
      flexDirection: "column",
      gap: Spacing.S,
      alignSelf: "stretch",
      minHeight,
      p: Spacing.L,
      border: "1px dashed",
      borderColor: "grey.300",
      // the corners of the package Card, as the item cards beside it
      borderRadius: Radius.XXXL,
      color: disabled ? "text.disabled" : "primary.main",
      transition: "border-color 150ms",
      "&:hover": { borderColor: "primary.main" },
      "&.Mui-focusVisible": { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: 2 },
    })}
  >
    <AddIcon sx={{ fontSize: ICON_SIZE }} />

    <Typography variant="body2" fontWeight={700} color="inherit">
      {title}
    </Typography>

    {subtitle && (
      <Typography variant="caption" color="text.secondary">
        {subtitle}
      </Typography>
    )}
  </ButtonBase>
);
